import { render } from "./StorePerformance.vue?vue&type=template&id=012c3036&scoped=true"
import script from "./StorePerformance.vue?vue&type=script&lang=js"
export * from "./StorePerformance.vue?vue&type=script&lang=js"

import "./StorePerformance.vue?vue&type=style&index=0&id=012c3036&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012c3036"]])

export default __exports__